export interface SingleMessageType {
  [key: string]: string;
}

export interface NestedMessagesType {
  [key: string]: NestedMessagesType | string;
}

export enum LocaleType {
  ENGLISH_US = 'en-US',
  // Add more languages here as needed
}

export type AllMessagesType = { [key in LocaleType]: NestedMessagesType };

export type IntlMessage = {
  id: string;
  defaultMessage?: string;
};
